import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreInvoice } from "../../api/apiInvoices";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useRestoreInvoice = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lang = i18n.language;

    const { mutate: restoreInvoiceMutate, isPending } = useMutation({
        mutationFn: (id) => restoreInvoice(id),
        onSuccess: (data, variables) => {
            toast.success(lang === "ar" ? "تم استعادة الفاتورة بنجاح" : "Invoice restored successfully");
            queryClient.invalidateQueries(["programInvoice"]);
            queryClient.invalidateQueries(["program"]);
        },
        onError: (error) => {
            const errorMessage =
                error.response?.data?.message ||
                (lang === "ar" ? "حدث خطأ أثناء استعادة الفاتورة" : "An error occurred while restoring the invoice");
            toast.error(errorMessage);
        },
    });

    return { restoreInvoiceMutate, isPending };
};

export default useRestoreInvoice;
